import image1 from "../../../assets/images/baby/IMG_1967.JPG"
import image2 from "../../../assets/images/baby/IMG_1968.JPG"
import image3 from "../../../assets/images/baby/IMG_1969.JPG"
import image4 from "../../../assets/images/baby/IMG_1970.JPG"
import image6 from "../../../assets/images/baby/IMG_1972.JPG"
import image7 from "../../../assets/images/baby/IMG_1973.JPG"
import image8 from "../../../assets/images/baby/IMG_1974.JPG"
import image9 from "../../../assets/images/baby/IMG_1975.JPG"
import image10 from "../../../assets/images/baby/IMG_1976.JPG"
import image11 from "../../../assets/images/baby/IMG_1977.JPG"
import image12 from "../../../assets/images/baby/IMG_1978.JPG"




export const babyImages = [
    image1,
    image2,
    image3,
    image4,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12
]

